import { Doughnut } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';

ChartJS.register(ArcElement, Tooltip, Legend);

interface DoughnutChartProps {
  data: Array<{ dimension: string; value: number; percentage?: number }>;
  colors?: string[];
}

const DEFAULT_COLORS = [
  '#667eea',
  '#764ba2',
  '#f472b6',
  '#34d399',
  '#fbbf24',
  '#60a5fa',
  '#a78bfa',
  '#fb923c',
];

export function DoughnutChart({ data, colors = DEFAULT_COLORS }: DoughnutChartProps) {
  const chartData = {
    labels: data.map((d) => d.dimension),
    datasets: [
      {
        data: data.map((d) => d.value),
        backgroundColor: colors.slice(0, data.length),
        borderWidth: 0,
        hoverOffset: 4,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    cutout: '60%',
    plugins: {
      legend: {
        position: 'right' as const,
        labels: {
          usePointStyle: true,
          pointStyle: 'circle',
          padding: 15,
          color: '#374151',
          font: {
            size: 12,
          },
        },
      },
      tooltip: {
        backgroundColor: '#1a1a2e',
        titleColor: '#fff',
        bodyColor: '#fff',
        padding: 12,
        callbacks: {
          label: (context: { dataIndex: number; formattedValue: string }) => {
            const item = data[context.dataIndex];
            if (item.percentage !== undefined) {
              return `${context.formattedValue} (${item.percentage.toFixed(1)}%)`;
            }
            return context.formattedValue;
          },
        },
      },
    },
  };

  return (
    <div style={{ height: '250px' }}>
      <Doughnut data={chartData} options={options} />
    </div>
  );
}
